import { SettingEditView, SettingListView } from '@/views/authenticated/settings';

export default [
  {
    path: '/settings',
    name: 'app_setting_list',
    meta: { title: 'Settings' },
    component: SettingListView,
  },
  {
    path: '/settings/:setting/edit',
    name: 'app_setting_edit',
    meta: { title: 'Edit a Setting' },
    component: SettingEditView,
  },
];
